/**
 * Environment configuration constants
 * Uses BUN_PUBLIC_* which are statically replaced at build time by Bun
 */

// Service URLs
const currentHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost'
let API_BASE_URL = `${window.location.protocol}//${currentHost}:3000`
let SOCKET_URL = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${currentHost}:3000`
let SITE_URL = `${window.location.protocol}//${currentHost}:3008`
let DASH_URL = `${window.location.protocol}//${currentHost}:3009`

try { API_BASE_URL = process.env.BUN_PUBLIC_IRIS_URL || API_BASE_URL } catch {}
try { SOCKET_URL = process.env.BUN_PUBLIC_SOCKET_URL || SOCKET_URL } catch {}
try { SITE_URL = process.env.BUN_PUBLIC_SITE_URL || SITE_URL } catch {}
try { DASH_URL = process.env.BUN_PUBLIC_DASH_URL || DASH_URL } catch {}

export { API_BASE_URL, SOCKET_URL, SOCKET_URL as IRIS_SOCKET_URL, SITE_URL, DASH_URL }

// Development mode detection
export const IS_DEV_MODE = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   process.env.NODE_ENV === 'development')

// Common endpoints - all using consistent /v1/ prefix
export const ENDPOINTS = {
  AUTH: {
    GOOGLE: '/v1/auth/google',
    INTERNAL_CALLBACK: '/v1/auth/internal/callback',
    TOKEN_REFRESH: '/v1/auth/token/refresh'
  },
  USERS: {
    ME: '/v1/users/me',
    DASHBOARD: '/v1/users/me/dashboard'
  },
  WORKFLOWS: '/v1/workflows',
  BILLING: {
    OVERVIEW: '/v1/billing/overview',
    USAGE: '/v1/billing/usage',
    TRANSACTIONS: '/v1/billing/transactions'
  },
  PUBLIC: {
    GALLERY_WORKFLOWS: '/v1/public/gallery/workflows.json',
    GALLERY_FLOWS: '/v1/public/gallery/flows.json',
    INTEGRATIONS: '/v1/public/integrations.json',
    DOCUMENTATION: '/v1/public/documentation.json'
  }
} as const

// Auth configuration
export const AUTH_CONFIG = {
  TOKEN_STORAGE_KEY: 'lavender_auth_state',
  SIMPLE_TOKEN_KEY: 'lavender_auth_token',
  TOKEN_EXPIRY_HOURS: 24
} as const

// Log configuration URLs (only in development)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('[Config] Service URLs:', {
    API_BASE_URL,
    SOCKET_URL,
    SITE_URL,
    DASH_URL
  })
}